/* eslint-disable */
"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WixAtlasServiceWeb = void 0;
var http_1 = require("@wix/ambassador/runtime/http");
var WixAtlasServiceWeb = function (baseUrl, httpClientConfig) {
    var httpClient = new http_1.AmbassadorHTTPClient(baseUrl, httpClientConfig);
    return {
        AutocompleteServiceV1: function () {
            return function (headers) {
                var service = {
                    getPredictions: function (getPredictionsRequest) {
                        return httpClient.invoke('GET', '/api/v1/autocomplete/get-predictions', getPredictionsRequest, headers);
                    }
                };
                service.getPredictions.__http_method = 'GET';
                service.getPredictions.__http_url = '/api/v1/autocomplete/get-predictions';
                return service;
            };
        },
        AutocompleteServiceV2: function () {
            return function (headers) {
                var service = {
                    listPredictions: function (listPredictionsRequest) {
                        return httpClient.invoke('GET', '/v2/predictions', listPredictionsRequest, headers);
                    },
                    predict: function (predictRequest) {
                        return httpClient.invoke('POST', '/v2/predict', predictRequest, headers);
                    }
                };
                service.listPredictions.__http_method = 'GET';
                service.listPredictions.__http_url = '/v2/predictions';
                service.predict.__http_method = 'POST';
                service.predict.__http_url = '/v2/predict';
                return service;
            };
        },
        LocationServiceV1: function () {
            return function (headers) {
                var service = {
                    search: function (searchRequestV1) {
                        return httpClient.invoke('GET', '/api/v1/search', searchRequestV1, headers);
                    },
                    searchByZipCode: function (searchByZipCodeRequest) {
                        return httpClient.invoke('GET', '/api/v1/search-by-zip-code', searchByZipCodeRequest, headers);
                    }
                };
                service.search.__http_method = 'GET';
                service.search.__http_url = '/api/v1/search';
                service.searchByZipCode.__http_method = 'GET';
                service.searchByZipCode.__http_url = '/api/v1/search-by-zip-code';
                return service;
            };
        },
        LocationServiceV2: function () {
            return function (headers) {
                var service = {
                    search: function (searchRequest) {
                        return httpClient.invoke('GET', '/v2/search', searchRequest, headers);
                    }
                };
                service.search.__http_method = 'GET';
                service.search.__http_url = '/v2/search';
                return service;
            };
        },
        MapsWidgetServiceV0: function () {
            return function (headers) {
                var service = {
                    getAppleEmbedMap: function (getAppleEmbedMapRequest) {
                        return httpClient.invoke('GET', '/api/v1/dynamic-map-token', getAppleEmbedMapRequest, headers);
                    },
                    getAtlasStaticMap: function (getAtlasStaticMapRequest) {
                        return httpClient.invoke('GET', '/api/v1/atlas-static-map', getAtlasStaticMapRequest, headers);
                    },
                    getEmbedMap: function (getEmbedMapRequest) {
                        return httpClient.invoke('GET', '/api/v1/embed-map', getEmbedMapRequest, headers);
                    },
                    getSnapshotMap: function (getSnapshotMapRequest) {
                        return httpClient.invoke('GET', '/api/v1/snapshot-map', getSnapshotMapRequest, headers);
                    },
                    getStaticMap: function (getStaticMapRequest) {
                        return httpClient.invoke('GET', '/api/v1/static-map', getStaticMapRequest, headers);
                    }
                };
                service.getAppleEmbedMap.__http_method = 'GET';
                service.getAppleEmbedMap.__http_url = '/api/v1/dynamic-map-token';
                service.getAtlasStaticMap.__http_method = 'GET';
                service.getAtlasStaticMap.__http_url = '/api/v1/atlas-static-map';
                service.getEmbedMap.__http_method = 'GET';
                service.getEmbedMap.__http_url = '/api/v1/embed-map';
                service.getSnapshotMap.__http_method = 'GET';
                service.getSnapshotMap.__http_url = '/api/v1/snapshot-map';
                service.getStaticMap.__http_method = 'GET';
                service.getStaticMap.__http_url = '/api/v1/static-map';
                return service;
            };
        },
        PlacesServiceV1: function () {
            return function (headers) {
                var service = {
                    getPlace: function (serviceGetPlaceRequest) {
                        return httpClient.invoke('GET', '/api/v1/place/details', serviceGetPlaceRequest, headers);
                    }
                };
                service.getPlace.__http_method = 'GET';
                service.getPlace.__http_url = '/api/v1/place/details';
                return service;
            };
        },
        PlacesServiceV2: function () {
            return function (headers) {
                var service = {
                    getPlace: function (v2GetPlaceRequest) {
                        return httpClient.invoke('GET', '/v2/place', v2GetPlaceRequest, headers);
                    }
                };
                service.getPlace.__http_method = 'GET';
                service.getPlace.__http_url = '/v2/place';
                return service;
            };
        }
    };
};
exports.WixAtlasServiceWeb = WixAtlasServiceWeb;
exports.WixAtlasServiceWeb.__transport = 'http';
__exportStar(require("./types"), exports);
